import _delay from 'lodash/delay';

import vSelect from "vue-select";
import stickDropdownToSelect from '$utils/stickDropdownToSelect';

export default {
	props: {
		context: {
			type: Object,
			required: true
		},
	},

	components: {
		"v-select": vSelect,
	},

	mounted() {

	},

	data() {
		return {
			selectedOption: null
		};
	},

	computed: {

	},

	methods: {
		handleInput(value) {
			if (this.context.node && typeof this.context.node.input === 'function') {
				this.context.node.input(value);
			} else if (this.context.handlers && typeof this.context.handlers.input === 'function') {
				this.context.handlers.input(value);
			}
		},
		calculateSelectPostion(dropdownList, component, {width}) {
			stickDropdownToSelect(dropdownList, component, {
				width,
				offsetY: 10,
				align: 'right',
			});
		}
	},

	watch: {

	}
};
